import { Link } from "react-router-dom";
import type { MovieItem } from "@/mocks/content";
import { formatShortDate } from "@/lib/format";

export default function MovieCard({ movie }: { movie: MovieItem }) {
  return (
    <Link
      to={`/movies/${movie.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 红桃网影视推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
        <span className="absolute left-2.5 top-2.5 rounded-sm bg-background-50/90 px-2 py-1 text-[11px] font-medium text-primary-700">
          {movie.media}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-sm bg-accent-500 px-1.5 py-1 font-label text-[11px] font-bold text-accent-950">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between px-2.5 pb-2 text-[11px] text-background-100/85">
          <span className="font-label">{movie.year}</span>
          <span>{movie.region}</span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="font-heading text-[15px] font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 line-clamp-1">
          {movie.title}
        </h3>
        <p className="mt-1.5 truncate text-xs text-foreground-500">
          导演 {movie.director} · {movie.cast.slice(0, 2).join(" / ")}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          {movie.genres.slice(0, 2).map((genre) => (
            <span key={genre} className="rounded-sm bg-background-100 px-1.5 py-0.5 text-[11px] text-foreground-600">
              {genre}
            </span>
          ))}
          <span className="ml-auto font-label text-[10px] text-foreground-300">{formatShortDate(movie.publishedAt)}</span>
        </div>
      </div>
    </Link>
  );
}